<template>
  <v-dialog activator="parent" max-width="500">
    <template v-slot:default="{ isActive }">
      <v-card rounded="lg">
        <v-card-title class="d-flex justify-space-between align-center">
          <h2 class="form-title">
            {{ $t("Products.addToPriceList.title") }}
          </h2>
          <v-btn
            icon="mdi-close"
            variant="text"
            @click="
              () => {
                isActive.value = false;
                closeModel();
              }
            "
          ></v-btn>
        </v-card-title>

        <div class="form-card">
          <div class="pr-4">
             מוצר:
            <span class="productName">
              {{ productName }}
            </span>
          </div>
          <div class="py-4 pr-4">
            {{ $t("Products.addToPriceList.message") }}
          </div>

          <div ref="turnstile" class="d-flex justify-center mt-2"></div>

          <v-card-actions class="my-2 d-flex justify-end">
            <v-btn
              class="text-none cancel"
              :text="$t('Products.addToPriceList.cancel')"
              @click="
                () => {
                  isActive.value = false;
                  closeModel();
                }
              "
            ></v-btn>

            <v-btn
              class="text-none"
              color="#bd9478"
              :loading="isLodingSendRquest"
              :disabled="isLodingSendRquest"
              :text="$t('Products.addToPriceList.send')"
              @click="handleSubmit"
              variant="flat"
            ></v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
import { getTurnstileToken } from "@/services/turnstile";

export default {
  name: "AddToPriceListModal",
  emits: ["submit", "closeModel"],
  props: {
    productName: {
      type: String,
    },
    isLodingSendRquest: {
      type: Boolean,
    },
  },
  data() {
    return {};
  },
  methods: {
    closeModel() {
      this.$emit("closeModel");
    },
    async handleSubmit() {
      try {
        const token = await getTurnstileToken(
          "submit_form",
          this.$refs.turnstile
        );
        this.$emit("submit", token);
      } catch (error) {
        console.error("Submit error:", error);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.form-card {
  padding: 25px;
  padding-bottom: 0px;
}

.productName {
  font-weight: 700;
}

.form-title {
  padding: 25px;
  padding-bottom: 0;
}

.cancel {
  border: 1px solid #bd9478;
  color: #bd9478;
}

@media (max-width: 601px) {
  .form-title {
    font-size: 20px !important;
  }
}
</style>
